import { Input, InputProps } from 'antd';
import {
  InputComponentWrapper,
  InputComponentWrapperProps,
} from 'baseComponents/InputComponentWrapper';
import './styles.scss';

type TextInputComponentProps = InputProps &
  Pick<
    InputComponentWrapperProps,
    'error' | 'description' | 'fullWidth' | 'label'
  >;

export const TextInputComponent = ({
  error,
  description,
  label,
  fullWidth,
  ...rest
}: TextInputComponentProps) => (
  <InputComponentWrapper {...{ error, description, label, fullWidth }}>
    <Input className='pj-input' status={error ? 'error' : ''} {...rest} />
  </InputComponentWrapper>
);
